// extracted by mini-css-extract-plugin
export default {"sidebar":"styles_sidebar__QZGXV","closeIcon":"styles_closeIcon__81VSF","listItemBtn":"styles_listItemBtn__CSY98","active":"styles_active__Ui5I3"};